import { SuggestionOption } from '@uikit/components/FormFieldSuggestion/interfaces';

export const titleFormFieldOptions: SuggestionOption[] = [
  { value: '-', label: 'Kein Titel' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Prof.', label: 'Prof.' },
];
